'use strict';

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var errCode = require('err-code');

var _require = require('./errors'),
    messages = _require.messages,
    codes = _require.codes;

var all = require('it-all');

var pAny = require('p-any');

module.exports = function (node) {
  var routers = node._modules.contentRouting || [];
  var dht = node._dht; // If we have the dht, make it first

  if (dht) {
    routers.unshift(dht);
  }

  return {
    /**
     * Iterates over all content routers in series to find providers of the given key.
     * Once a content router succeeds, iteration will stop.
     *
     * @param {CID} key The CID key of the content to find
     * @param {object} [options]
     * @param {number} [options.timeout] How long the query should run
     * @param {number} [options.maxNumProviders] - maximum number of providers to find
     * @returns {AsyncIterable<PeerInfo>}
     */
    findProviders: function findProviders(key, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var result, _iterator, _step, pInfo;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (routers.length) {
                  _context2.next = 2;
                  break;
                }

                throw errCode(new Error('No content routers available'), 'NO_ROUTERS_AVAILABLE');

              case 2:
                _context2.next = 4;
                return _awaitAsyncGenerator(pAny(routers.map( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(router) {
                    var provs;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return all(router.findProviders(key, options));

                          case 2:
                            provs = _context.sent;

                            if (!(!provs || !provs.length)) {
                              _context.next = 5;
                              break;
                            }

                            throw errCode(new Error('not found'), 'NOT_FOUND');

                          case 5:
                            return _context.abrupt("return", provs);

                          case 6:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }())));

              case 4:
                result = _context2.sent;
                _iterator = _createForOfIteratorHelper(result);
                _context2.prev = 6;

                _iterator.s();

              case 8:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 14;
                  break;
                }

                pInfo = _step.value;
                _context2.next = 12;
                return pInfo;

              case 12:
                _context2.next = 8;
                break;

              case 14:
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](6);

                _iterator.e(_context2.t0);

              case 19:
                _context2.prev = 19;

                _iterator.f();

                return _context2.finish(19);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 16, 19, 22]]);
      }))();
    },

    /**
     * Iterates over all content routers in parallel to notify it is
     * a provider of the given key.
     *
     * @param {CID} key The CID key of the content to find
     * @returns {Promise<void>}
     */
    provide: function provide(key) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (routers.length) {
                  _context3.next = 2;
                  break;
                }

                throw errCode(new Error('No content routers available'), 'NO_ROUTERS_AVAILABLE');

              case 2:
                return _context3.abrupt("return", Promise.all(routers.map(function (router) {
                  return router.provide(key);
                })));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * Store the given key/value pair in the DHT.
     * @param {Buffer} key
     * @param {Buffer} value
     * @param {Object} [options] - put options
     * @param {number} [options.minPeers] - minimum number of peers required to successfully put
     * @returns {Promise<void>}
     */
    put: function put(key, value, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!node.isStarted() || !dht.isStarted)) {
                  _context4.next = 2;
                  break;
                }

                throw errCode(new Error(messages.NOT_STARTED_YET), codes.DHT_NOT_STARTED);

              case 2:
                return _context4.abrupt("return", dht.put(key, value, options));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    /**
     * Get the value to the given key.
     * Times out after 1 minute by default.
     * @param {Buffer} key
     * @param {Object} [options] - get options
     * @param {number} [options.timeout] - optional timeout (default: 60000)
     * @returns {Promise<{from: PeerId, val: Buffer}>}
     */
    get: function get(key, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(!node.isStarted() || !dht.isStarted)) {
                  _context5.next = 2;
                  break;
                }

                throw errCode(new Error(messages.NOT_STARTED_YET), codes.DHT_NOT_STARTED);

              case 2:
                return _context5.abrupt("return", dht.get(key, options));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * Get the `n` values to the given key without sorting.
     * @param {Buffer} key
     * @param {number} nVals
     * @param {Object} [options] - get options
     * @param {number} [options.timeout] - optional timeout (default: 60000)
     * @returns {Promise<Array<{from: PeerId, val: Buffer}>>}
     */
    getMany: function getMany(key, nVals, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!node.isStarted() || !dht.isStarted)) {
                  _context6.next = 2;
                  break;
                }

                throw errCode(new Error(messages.NOT_STARTED_YET), codes.DHT_NOT_STARTED);

              case 2:
                return _context6.abrupt("return", dht.getMany(key, nVals, options));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  };
};